<template>
  <typeahead
      ref="typeahead"
      :src="src"
      :placeholder="placeholder"
      @onSelect="onSelect">
    <template #item="{ item }">
      <span>
        {{item.first_name}} {{item.last_name}}
        <template v-if="(item.email !== '')">/&nbsp;{{ item.email }}</template>
        <template v-if="(item.phone !== '')">&nbsp;/&nbsp;{{ item.phone }}</template>
      </span>
    </template>
  </typeahead>
</template>

<script>
export default {

  emits: ['update:modelValue', 'adjusterSelected'],

  props: {

    // Input value (v-model).
    modelValue: {
      type: Object,
      default: () => {return {}}
    },

    // Typeahead placeholder text.
    placeholder: {
      type: String,
      default: "Specify name or email address to find adjuster..."
    },

    // Alternative url to search users.
    searchUrl: {
      type: String,
      default: ""
    },

  },

  data () {
    return {
      // Selected adjuster.
      adjuster: {},

      // The source url.
      src: '/webapi/adjuster/search'
    }
  },

  methods: {
    onSelect (data) {
      this.setAdjuster(data.item);
      this.$refs.typeahead.focus();
    },

    setAdjuster(adjuster) {
      this.adjuster = adjuster;
      this.$emit('update:modelValue', adjuster);
      this.$emit('adjusterSelected', adjuster);
    },
  },

  mounted: function () {
    if (this.modelValue) {
      this.adjuster = this.modelValue;
    }
    if (this.searchUrl) {
      this.src = this.searchUrl;
    }
  }
}
</script>
